<ng-container *ngIf="show | async">
    <fcp-summary-bar
        [title]="title | async"
        [summary]="summary | async"
        [button]="button | async"
        [splitButton]="splitButton | async"
        [secondaryButton]="secondaryButton | async"
        [secondSecondaryButton]="secondSecondaryButton | async"
        (onClick)="onClick()"
        (onSecondaryClick)="onSecondaryClick()"
        (onSecondSecondaryClick)="onSecondSecondaryClick()"
        (onSplitMenuClick)="onSplitButtonClick()"
    ></fcp-summary-bar>
</ng-container>
